<div class="navigation-items action-items navigation-border-right">
  <div class="action-icon" *ngIf="searchActive" (click)="resetSearch()">
    <svg-icon src='./assets/icons/showAll.svg' title="{{'projectToolbar.showAll' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.showAll' | translate | uppercase"></div>
  </div>
    <div class="action-icon" (click)="search()">
      <svg-icon src='./assets/icons/search-outline.svg' title="{{'calculationModel.search' | translate | uppercase}}"
                class="menu-action-icon svg-icon-gray"></svg-icon>
      <div class="icon-label" [innerHTML]="'calculationModel.search' | translate | uppercase"></div>
    </div>
    <div class="action-icon" (click)="setActiveTab(AdminTab.CalculationModelRegister)">
      <svg-icon src='./assets/icons/add_new.svg' title="{{'calculationModel.register' | translate | uppercase}}"
                class="menu-action-icon svg-icon-gray"></svg-icon>
      <div class="icon-label" [innerHTML]="'calculationModel.register' | translate | uppercase"></div>
    </div>
  </div>
  <div class="navigation-items action-items"  *ngIf="cmService.selectedId$ | async">
    <div class="action-icon" (click)="edit()">
      <svg-icon src='./assets/icons/create-outline.svg' title="{{'calculationModel.edit' | translate | uppercase}}"
                class="menu-action-icon svg-icon-gray"></svg-icon>
      <div class="icon-label" [innerHTML]="'calculationModel.edit' | translate | uppercase"></div>
    </div>
    <div class="action-icon" (click)="archive()" *ngIf="!(cmService.statusId$ | async)">
      <svg-icon src='./assets/icons/archive-outline.svg' title="{{'calculationModel.archive' | translate | uppercase}}"
                class="menu-action-icon svg-icon-gray"></svg-icon>
      <div class="icon-label" [innerHTML]="'calculationModel.archive' | translate | uppercase"></div>
    </div>
  </div>
  
